var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Dialog } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export var IndependentDialog = styled(Dialog)(function (props) { return ({
    '&&': {
        pointerEvents: props.hideBackdrop ? 'none' : 'all',
        '& .react-draggable': {
            pointerEvents: 'all'
        }
    }
}); });
var templateObject_1;
//# sourceMappingURL=DraggableDialog.Styles.js.map